var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValuenew3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276",
    transform: "translate(-5241 -2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(5241 2052)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(5269.163 2081.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medal",
    transform: "translate(6.91 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M42.626,41.1,37.474,27.552a4.411,4.411,0,0,0,1.3-1.187,4.337,4.337,0,0,0,.7-3.625,2.947,2.947,0,0,1,.992-2.985,4.348,4.348,0,0,0-.008-6.733,2.947,2.947,0,0,1-.982-2.987,4.334,4.334,0,0,0-.7-3.617A4.445,4.445,0,0,0,35.462,4.6a3.031,3.031,0,0,1-2.591-1.851A4.411,4.411,0,0,0,30.144.223,4.482,4.482,0,0,0,26.4.669a3.08,3.08,0,0,1-3.212,0A4.482,4.482,0,0,0,19.438.223a4.412,4.412,0,0,0-2.726,2.523,3.033,3.033,0,0,1-2.6,1.852,4.44,4.44,0,0,0-3.306,1.822,4.337,4.337,0,0,0-.7,3.625,2.947,2.947,0,0,1-.992,2.985,4.348,4.348,0,0,0,.008,6.732,2.947,2.947,0,0,1,.982,2.987,4.334,4.334,0,0,0,.7,3.617,4.411,4.411,0,0,0,1.3,1.187L6.957,41.1a.712.712,0,0,0,.907.924L13.475,40l2.851,5.236a.712.712,0,0,0,.626.372l.048,0a.713.713,0,0,0,.618-.458l4.823-12.674a4.487,4.487,0,0,0,.745-.363,3.081,3.081,0,0,1,3.211,0h0a4.48,4.48,0,0,0,.742.358l4.825,12.679a.713.713,0,0,0,.618.458l.048,0a.712.712,0,0,0,.626-.372L36.108,40l5.611,2.017a.712.712,0,0,0,.907-.924ZM16.837,43.2l-2.4-4.411a.713.713,0,0,0-.866-.33l-4.728,1.7,4.593-12.074a4.547,4.547,0,0,0,.688.106,3.031,3.031,0,0,1,2.591,1.851,4.411,4.411,0,0,0,2.727,2.523,4.505,4.505,0,0,0,1.363.218Zm5.6-12.3a3.055,3.055,0,0,1-2.556.3A2.988,2.988,0,0,1,18.031,29.5a4.468,4.468,0,0,0-3.821-2.734,3.02,3.02,0,0,1-2.249-1.237,2.914,2.914,0,0,1-.467-2.437,4.38,4.38,0,0,0-1.467-4.434,2.923,2.923,0,0,1,.008-4.535,4.38,4.38,0,0,0,1.457-4.436,2.911,2.911,0,0,1,.469-2.43,3.025,3.025,0,0,1,2.256-1.238,4.465,4.465,0,0,0,3.813-2.733A2.985,2.985,0,0,1,19.88,1.578a3.058,3.058,0,0,1,2.557.3,4.518,4.518,0,0,0,4.71,0,3.057,3.057,0,0,1,2.556-.3,2.988,2.988,0,0,1,1.849,1.707,4.468,4.468,0,0,0,3.821,2.734,3.02,3.02,0,0,1,2.249,1.237,2.914,2.914,0,0,1,.467,2.437,4.38,4.38,0,0,0,1.467,4.434,2.923,2.923,0,0,1-.008,4.535A4.38,4.38,0,0,0,38.09,23.1a2.91,2.91,0,0,1-.469,2.43,3.024,3.024,0,0,1-2.256,1.238A4.465,4.465,0,0,0,31.551,29.5,2.985,2.985,0,0,1,29.7,31.206a3.052,3.052,0,0,1-2.557-.3,4.518,4.518,0,0,0-4.71,0Zm13.579,7.554a.713.713,0,0,0-.866.33l-2.4,4.411L28.782,32.781a4.508,4.508,0,0,0,1.362-.219,4.413,4.413,0,0,0,2.728-2.523,3.031,3.031,0,0,1,2.6-1.851,4.506,4.506,0,0,0,.682-.105l4.592,12.074Z",
    transform: "translate(-6.91 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M38.38,18.69A10.69,10.69,0,1,0,27.69,29.38,10.69,10.69,0,0,0,38.38,18.69ZM27.69,27.955a9.265,9.265,0,1,1,9.265-9.265,9.265,9.265,0,0,1-9.265,9.265Z",
    transform: "translate(-9.809 -2.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M35.137,18.064l-3.475-.5L30.108,14.41a.742.742,0,0,0-1.278,0l-1.554,3.149-3.475.5a.713.713,0,0,0-.4,1.216l2.515,2.451-.594,3.461a.713.713,0,0,0,1.033.751l3.108-1.634,3.108,1.634a.713.713,0,0,0,1.033-.751l-.594-3.461,2.515-2.451a.713.713,0,0,0-.4-1.216Zm-3.383,2.908a.714.714,0,0,0-.2.631l.413,2.407L29.8,22.873a.712.712,0,0,0-.663,0l-2.161,1.136.413-2.407a.714.714,0,0,0-.2-.631l-1.749-1.7,2.416-.351a.712.712,0,0,0,.537-.39l1.081-2.189,1.081,2.189a.712.712,0,0,0,.537.39l2.416.351Z",
    transform: "translate(-11.588 -4.036)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuenew3);
export default __webpack_public_path__ + "static/media/valuenew3.60d654a73ab6f23ccd8a8b3cbd4304f0.svg";
export { ForwardRef as ReactComponent };